module.exports = __webpack_public_path__ + "static/img/banner.610d889e.png";